import { IAction } from "../../../../interface/action.interface";
import { IListDetailsDto } from "../../interface/dto/list-details.dto";

export enum ListDetailsActionType {
    LIST_DETAILS_GET = "LIST_DETAILS_GET",
    LIST_DETAILS_GET_SUCCESS = "LIST_DETAILS_GET_SUCCESS",
    LIST_DETAILS_GET_ERROR = "LIST_DETAILS_GET_ERROR",
    LIST_TRACK = "LIST_TRACK",
    LIST_TRACK_ERROR = "LIST_TRACK_ERROR",
    LIST_TRACK_SUCCESS = "LIST_TRACK_SUCCESS",
    LIST_DETAILS_NOT_FOUND = "LIST_DETAILS_NOT_FOUND",
}

export interface IListDetailsGetAction extends IAction {
    type: ListDetailsActionType.LIST_DETAILS_GET;
    payload: {
        listId: number;
    };
}

export interface IListDetailsGetSuccessAction extends IAction {
    type: ListDetailsActionType.LIST_DETAILS_GET_SUCCESS;
    payload: IListDetailsDto;
}

export interface IListDetailsGetErrorAction extends IAction {
    type: ListDetailsActionType.LIST_DETAILS_GET_ERROR;
    payload: {
        error: string;
    };
}

export interface ITrackListAction extends IAction {
    type: ListDetailsActionType.LIST_TRACK;
    payload: {
        track: boolean;
    };
}
export interface ITrackListErrorAction extends IAction {
    type: ListDetailsActionType.LIST_TRACK_ERROR;
    payload: {
        error: string;
    };
}
export interface ITrackListSuccessAction extends IAction {
    type: ListDetailsActionType.LIST_TRACK_SUCCESS;
}

export interface IListDetailsNotFoundAction extends IAction {
    type: ListDetailsActionType.LIST_DETAILS_NOT_FOUND;
    payload: null;
}

export const listDetailsGetAction = (
    listId: number,
): IListDetailsGetAction => ({
    type: ListDetailsActionType.LIST_DETAILS_GET,
    payload: {
        listId,
    },
});

export const listDetailsSuccessAction = (
    listDetails: IListDetailsDto,
): IListDetailsGetSuccessAction => ({
    type: ListDetailsActionType.LIST_DETAILS_GET_SUCCESS,
    payload: listDetails,
});

export const listDetailsErrorAction = (error: string) => ({
    type: ListDetailsActionType.LIST_DETAILS_GET_ERROR,
    payload: { error },
});

export const trackListAction = (track: boolean) => ({
    type: ListDetailsActionType.LIST_TRACK,
    payload: { track },
});

export const listTrackSuccessAction = (): ITrackListSuccessAction => ({
    type: ListDetailsActionType.LIST_TRACK_SUCCESS,
    payload: null,
});

export const listTrackErrorAction = (error: string) => ({
    type: ListDetailsActionType.LIST_TRACK_ERROR,
    payload: { error },
});

export const listDetailsNotFoundAction = (): IListDetailsNotFoundAction => ({
    type: ListDetailsActionType.LIST_DETAILS_NOT_FOUND,
    payload: null,
});

export type IListDetailsAction =
    | IListDetailsGetAction
    | IListDetailsGetSuccessAction
    | IListDetailsGetErrorAction
    | ITrackListAction
    | ITrackListErrorAction
    | ITrackListSuccessAction
    | IListDetailsNotFoundAction;
